import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ReportsLibraryComponentsHttpClient } from './library-components.http-client';
import {
  COMPONENTS_LIBRARY_SCOPE,
  ReportsLibraryComponentsActions,
} from './library-components.store';

@Injectable({
  providedIn: 'root',
})
export class ReportsLibraryComponentsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(ReportsLibraryComponentsHttpClient);

  public effects = createEffectFactory(ReportsLibraryComponentsActions, this.actions$);

  public fetchCollection$ = this.effects(ReportsLibraryComponentsActions.fetchCollection, () =>
    this.http.fetchCollection().pipe(
      map(({ componentTemplates }) => ({
        data: componentTemplates,
        scope: COMPONENTS_LIBRARY_SCOPE,
      })),
    ),
  );
}
